import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  allReports: null,
  reportDetails: null,
  loading: false,
  error: null,
  adminResponse: null,
}

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    getAllReportsRequest: (state) => {
      state.loading = true
      state.error = null
    },
    getAllReportsSuccess: (state, action) => {
      state.loading = false
      state.error = null
      state.allReports = action.payload
      console.log('Redux: All reports loaded:', action.payload)
    },
    getAllReportsFail: (state, action) => {
      state.loading = false
      state.error = action.payload
      state.allReports = null
    },

    getReportDetailsRequest: (state) => {
      state.loading = true
      state.error = null
    },
    getReportDetailsSuccess: (state, action) => {
      state.loading = false
      state.error = null
      state.reportDetails = action.payload
      console.log('Redux: Report details loaded:', action.payload)
    },
    getReportDetailsFail: (state, action) => {
      state.loading = false
      state.error = action.payload
      state.reportDetails = null
    },

    sendAdminResponseRequest: (state) => {
      state.loading = true
      state.error = null
    },
    sendAdminResponseSuccess: (state, action) => {
      state.loading = false
      state.error = null
      state.adminResponse = action.payload
      
      const responseData = action.payload.data || action.payload
      const reportId = responseData.reportId || responseData._id
      
      if (state.allReports?.reports && reportId) {
        const reportIndex = state.allReports.reports.findIndex(
          report => report._id === reportId
        )
        if (reportIndex !== -1) {
          state.allReports.reports[reportIndex] = {
            ...state.allReports.reports[reportIndex],
            isResponded: true,
            status: 'RESPONDED',
            adminResponse: responseData
          }
        }
      }
      
      if (state.reportDetails && state.reportDetails._id === reportId) {
        state.reportDetails = {
          ...state.reportDetails,
          isResponded: true,
          status: 'RESPONDED',
          adminResponse: responseData
        }
      }
    },
    sendAdminResponseFail: (state, action) => {
      state.loading = false
      state.error = action.payload
    },

    deleteReportRequest: (state) => {
      state.loading = true
      state.error = null
    },
    deleteReportSuccess: (state, action) => {
      state.loading = false
      state.error = null
      
      if (state.allReports?.reports && action.payload.reportId) {
        state.allReports.reports = state.allReports.reports.filter(
          report => report._id !== action.payload.reportId
        )
      }
      
      if (state.reportDetails && state.reportDetails._id === action.payload.reportId) {
        state.reportDetails = null
      }
    },
    deleteReportFail: (state, action) => {
      state.loading = false
      state.error = action.payload
    },

    clearReportsError: (state) => {
      state.error = null
    },

    clearReportsData: (state) => {
      state.allReports = null
      state.reportDetails = null
      state.adminResponse = null
      state.error = null
    }
  }
})

export const {
  getAllReportsRequest,
  getAllReportsSuccess,
  getAllReportsFail,
  getReportDetailsRequest,
  getReportDetailsSuccess,
  getReportDetailsFail,
  sendAdminResponseRequest,
  sendAdminResponseSuccess,
  sendAdminResponseFail,
  deleteReportRequest,
  deleteReportSuccess,
  deleteReportFail,
  clearReportsError,
  clearReportsData
} = reportsSlice.actions

export default reportsSlice.reducer